import classnames from 'classnames'
import React from 'react'
import { useDispatch } from 'react-redux'
import { ROUTE_ADDRESS, ROUTE_SEO_GEOENTITY } from '../../../../routes'
import { resetGeoentityList } from '../../../../store/geoentity/geoentitySlice'
import { navigateTo } from '../../../../store/history/history.actions'
import { setSearchTerms } from '../../../../store/search/searchSlice'
import ActionButton from '../../../genericComponents/buttons/ActionButton'
import TagActionButton from '../../../genericComponents/TagActionButton'
import Throbber from '../../../loading/Throbber'
import SVGIcon from '../../../svg/SVGIcon'
import { useAction } from '../../../utils/react-redux'
import useEventCallback from '../../../utils/useEventCallback'
import s from './UserFavoriteItem.less'

const FavoriteContent = ({ label, address, tagData }) => {
  return (
    <TagActionButton className={s.content} {...tagData}>
      {label ? (
        <>
          <div className={s.label}>{label}</div>
          <div className={s.address}>{address}</div>
        </>
      ) : (
        <div className={s.label}>{address}</div>
      )}
    </TagActionButton>
  )
}

export const UserFavoriteItem = ({
  poiId,
  uuid,
  label,
  address,
  favIcon,
  action,
  actionIcon,
  allowEmpty = false,
  editTagData,
  gotoTagData
}) => {
  const dispatch = useDispatch()
  const updating = !allowEmpty && !uuid
  const execNavigateTo = useAction(navigateTo)

  const onItemClick = useEventCallback(() => {
    if (!uuid) {
      action()
    } else {
      dispatch(resetGeoentityList())
      if (poiId) {
        execNavigateTo({ route: ROUTE_SEO_GEOENTITY, routeOptions: { geoentityId: poiId } })
      } else {
        dispatch(setSearchTerms(address))
        execNavigateTo({ route: ROUTE_ADDRESS, routeOptions: { location: address } })
      }
    }
  }, [uuid, label, address, poiId])

  const onButtonClick = useEventCallback(() => {
    action(uuid)
  })

  return (
    <div className={classnames(s.root, s.clickableContent, updating && s.updating)} onClick={onItemClick}>
      <div className={classnames(s.favIcon, s[favIcon])}>
        <SVGIcon icon={favIcon} />
      </div>
      <FavoriteContent label={label} address={address} tagData={gotoTagData} />
      <div className={s.actions}>
        {updating ? (
          <Throbber />
        ) : (
          uuid && (
            <ActionButton className={s.actionButton} tagData={editTagData} onClick={onButtonClick}>
              <SVGIcon icon={actionIcon} />
            </ActionButton>
          )
        )}
      </div>
    </div>
  )
}

export default UserFavoriteItem
